import { FormInput } from "@circle-react-shared/uikit/Form/FormInput";
import { FormSelect } from "@circle-react-shared/uikit/Form/FormSelect";
import { FormTextArea } from "@circle-react-shared/uikit/Form/FormTextArea";
import type { Paywall } from "@circle-react/types/Paywall";
import { Alert } from "@circleco/compass/components/Alert";

import { t } from "@/i18n-js/instance";
import { Item as FormItem } from "@/react/components/SettingsApp/CompassCompat/FormItem";

interface PaywallFormFieldsProps {
  isError?: boolean;
  isLoading?: boolean;
  paywalls: Paywall[];
}

export const PaywallFormFields = ({
  paywalls,
  isLoading = false,
  isError = false,
}: PaywallFormFieldsProps) => {
  const paywallOptions = paywalls.map(p => ({
    text: p.display_name,
    value: p.id,
  }));

  return (
    <div className="flex flex-col gap-y-6">
      {isError && (
        <Alert
          variant="destructive"
          description={t("email_editor.paywall.load_error")}
        />
      )}

      <FormItem
        name="paywall_id"
        hidePlaceholder
        hideDescription
        hideBorder
        label={t("email_editor.paywall.select_paywall")}
        required
        isFirstChild
      >
        <FormSelect
          name="paywall_id"
          data={paywallOptions}
          disabled={isLoading}
          placeholder={
            isLoading
              ? t("email_editor.paywall.loading_paywalls")
              : t("email_editor.paywall.select_paywall")
          }
        />
      </FormItem>

      <FormItem
        name="title"
        hidePlaceholder
        hideDescription
        hideBorder
        isFirstChild
        label={t("email_editor.paywall.title")}
        required
      >
        <FormInput
          name="title"
          label={t("email_editor.paywall.title")}
          placeholder={t("email_editor.paywall.title")}
          autocomplete="off"
        />
      </FormItem>

      <FormItem
        name="description"
        hidePlaceholder
        hideDescription
        hideBorder
        isFirstChild
        label={t("email_editor.paywall.description")}
        required
      >
        <FormTextArea
          name="description"
          autoSize={{ minRows: 3 }}
          placeholder={t("email_editor.paywall.description")}
        />
      </FormItem>

      <FormItem
        name="button_text"
        hidePlaceholder
        hideDescription
        hideBorder
        isFirstChild
        label={t("email_editor.paywall.button_text")}
        required
      >
        <FormInput
          name="button_text"
          label={t("email_editor.paywall.button_text")}
          placeholder={t("email_editor.paywall.button_text")}
          autocomplete="off"
        />
      </FormItem>
    </div>
  );
};
